// pages/Dashboard.jsx
import Initiatives from "../components/initiativesComponents/Initiatives";
import HomeLayout from "../components/HomeLayout";

export default function InitiativesPage() {
  return (
    <HomeLayout>
      <Initiatives />
    </HomeLayout>
  );
}
